import { Box, Button, Card, CardContent, FormControl, Input, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import api from '../../../services/api';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import { ANAO, ASIM } from 'consts';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import ButtonBase from '@material-ui/core/ButtonBase';
import AddIcon from '@material-ui/icons/Add';
import { Autocomplete } from '@material-ui/lab';

class GrupoMsgWhatsAppFornecedor extends Component {
    state = {
        gruposmensagem: [],
        searchFilter: {
            nomeGrupoMensagem: '',
            situacaoInativoFilter: ANAO,
        },
        gruposAbertos: [],
        listaMensagens: [],
        groupSelectedAddMessage: 0,
        selectedValue: null,
        inputValue: ''
    };

    inputRef = React.createRef();

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        this.loadGruposMensagens();

        const { listaMensagens } = this.state;
        const mensagens = await api.get(`/whatsapp/mensagemfornecedor/active/true`);
        {
            mensagens.data.map((mensagem) => (
                listaMensagens.push({ idmsgwhats: mensagem.idmsgwhats, descricao: mensagem.descricao })
            ))
        };

        this.setState({
            listaMensagens
        })
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        value = value.toUpperCase();
        searchFilter[name] = value;
        this.setState({ searchFilter, groupSelectedAddMessage: 0 }, () => {
            if (name === 'situacaoInativoFilter') {
                this.loadGruposMensagens();
            }
        });
    };

    loadGruposMensagens = async () => {
        const { searchFilter } = this.state;
        let active = '';

        if (searchFilter.situacaoInativoFilter === ANAO) {
            active = '/active/true'
        } else if (searchFilter.situacaoInativoFilter === ASIM) {
            active = '/active/false'
        }

        let params = '';

        /* consulta pelo nome do grupo */
        if (searchFilter.nomeGrupoMensagem) {
            params += `?tbgrupomsgwhatsfornecedor.nome=_like_${searchFilter.nomeGrupoMensagem}`;
        }

        const grupomensagem = await api.get(`/whatsapp/grupomensagemfornecedor${active}${params}`);
        this.setState({
            gruposmensagem: grupomensagem.data,
            gruposAbertos: []
        });
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        let { searchFilter } = this.state;
        searchFilter.nomeGrupoMensagem = '';
        searchFilter.situacaoInativoFilter = ANAO;
        this.setState({ searchFilter });
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Alterna entre expandir/colapsar os grupos */
    toggleGrupo = (id) => {
        const { gruposAbertos } = this.state;
        if (gruposAbertos.includes(id)) {
            this.setState({
                gruposAbertos: gruposAbertos.filter(grupoId => grupoId !== id),
                groupSelectedAddMessage: 0
            });
        } else {
            this.setState({
                gruposAbertos: [...gruposAbertos, id],
                groupSelectedAddMessage: 0
            });
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpenDeleteGrupoConfirmation = (codgrupomensagem) => {
        this.setState({ openDeleteGrupoConfirmation: true });
        this.handleSelectGrupo(codgrupomensagem);
    };

    handleSelectGrupo = (id) => {
        this.setState({ selectedGrupo: id });
    };

    handleCloseDeleteGrupoConfirmation = () => {
        this.setState({ openDeleteGrupoConfirmation: false });
    };

    handleDeleteGrupo = async (id) => {
        try {
            const response = await api.delete(`/whatsapp/grupomensagemfornecedor/${id}`);
            if (response.status === 200) {
                this.handleCloseDeleteGrupoConfirmation();
                this.loadGruposMensagens();
            }
        } catch (error) {
            this.handleCloseDeleteGrupoConfirmation();
            this.handleOpenAlert(error.response.data.error);
            console.log(error.message);
        }
    };

    handleAddMensagem = (idgrupo) => {
        this.setState({ groupSelectedAddMessage: idgrupo });
    };

    handleAdicionarMensagemAoGrupo = async (idgrupo, mensagem) => {
        this.setState(prevState => {
            const novoGrupo = [...prevState.gruposmensagem];
            const grupoIndex = novoGrupo.findIndex(g => g.idgrupomsgwhats === idgrupo);

            if (grupoIndex !== -1) {
                const grupo = novoGrupo[grupoIndex];

                const jaExiste = grupo.mensagens.some(
                    m => m.idmsgwhats === mensagem.idmsgwhats
                );

                if (!jaExiste) {
                    this.insereMensagemGrupo(idgrupo, mensagem.idmsgwhats);

                    grupo.mensagens.push({
                        idmsgwhats: mensagem.idmsgwhats,
                        descricao: mensagem.descricao
                    });
                }
            }

            return { gruposMensagem: novoGrupo };
        });
    };

    insereMensagemGrupo = async (idgrupomsgwhats, idmsgwhats) => {
        let mensagemgrupo = {
            idgrupomsgwhats,
            idmsgwhats
        };

        try {
            const response = await api.post(`/whatsapp/mensagemgrupofornecedor`, mensagemgrupo);
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    handleDeleteMensagemGrupo = async (idgrupo, idmsgwhats) => {
        try {
            const response = await api.delete(`/whatsapp/mensagemgrupofornecedor/${idgrupo}/${idmsgwhats}`);
            if (response.status === 200) {
                this.setState((prevState) => ({
                    gruposmensagem: prevState.gruposmensagem.map((grupo) => {
                        if (grupo.idgrupomsgwhats === idgrupo) {
                            return {
                                ...grupo,
                                mensagens: grupo.mensagens.filter(
                                    (mensagem) => mensagem.idmsgwhats !== idmsgwhats
                                )
                            };
                        }
                        return grupo;
                    })
                }));
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
            console.log(error.message);
        }
    };

    render() {
        const { searchFilter } = this.state;
        const { gruposmensagem, gruposAbertos, listaMensagens, groupSelectedAddMessage } = this.state;
        const { selectedValue, inputValue } = this.state;

        return (
            <div style={this.estilo}>
                <div>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            backgroundColor: '#ffffff',
                            padding: '10px 16px',
                            borderRadius: '8px 8px 0 0',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <Typography
                            variant="h4"
                            style={{
                                fontWeight: 600,
                                letterSpacing: '0.5px',
                            }}
                        >
                            GRUPOS DE MENSAGENS
                        </Typography>

                        <Box style={{ display: 'flex', gap: 10 }}>
                            <Button
                                component={Link}
                                to="/crm/msgwhatsappfornecedor"
                                variant="contained"
                                color="primary"
                                style={this.estilo.addButton}
                            >
                                Mensagens
                            </Button>
                            <Button
                                component={Link}
                                to="/crm/grupomsgwhatsappfornecedor/novo"
                                variant="contained"
                                color="primary"
                                style={this.estilo.addButton}
                            >
                                Novo Grupo
                            </Button>
                        </Box>
                    </Box>

                    <Paper style={{ marginBottom: 10, marginTop: 10, padding: 10 }}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                            <Input
                                autoFocus
                                id="nomeGrupoMensagem"
                                name="nomeGrupoMensagem"
                                onChange={this.OnChangeSearch}
                                placeholder="Nome grupo de mensagem a pesquisar"
                                style={{ width: 300 }}
                                value={searchFilter.nomeGrupoMensagem}
                            />

                            <Select
                                id="situacaoInativoFilter"
                                name="situacaoInativoFilter"
                                value={searchFilter.situacaoInativoFilter || ''}
                                onChange={this.OnChangeSearch}
                            >
                                <MenuItem value={ANAO}>Ativos</MenuItem>
                                <MenuItem value={ASIM}>Inativos</MenuItem>
                                <MenuItem value={'T'}>Todos</MenuItem>
                            </Select>

                            <Button color="primary" id="pesquisar" onClick={this.loadGruposMensagens}>
                                <SearchIcon />
                            </Button>

                            <Button color="primary" onClick={this.LimpaFiltros}>
                                <ClearAllIcon />
                            </Button>
                        </Box>
                    </Paper>

                    <Card>
                        <CardContent>
                            <PerfectScrollbar>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: '100px', maxWidth: '100px' }}>Código</TableCell>
                                            <TableCell>Grupo</TableCell>
                                            <TableCell>Ações</TableCell>
                                            <TableCell align="right"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {gruposmensagem.map(grupo => (
                                            <React.Fragment key={grupo.idgrupomsgwhats}>
                                                {/* Linha principal do grupo */}
                                                <TableRow hover>
                                                    <TableCell style={(grupo.inativo === ASIM) ? this.estilo.redText : {}}>{grupo.idgrupomsgwhats}</TableCell>
                                                    <TableCell style={(grupo.inativo === ASIM) ? this.estilo.redText : {}}>{grupo.nome}</TableCell>
                                                    <TableCell>
                                                        <Link to={`/crm/grupomsgwhatsappfornecedor/${grupo.idgrupomsgwhats}`}>
                                                            <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                        </Link>
                                                        <DeleteForeverOutlinedIcon
                                                            onClick={() => this.handleOpenDeleteGrupoConfirmation(grupo.idgrupomsgwhats)}
                                                            style={{ cursor: 'pointer', marginRight: '10px' }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Button onClick={() => this.toggleGrupo(grupo.idgrupomsgwhats)}>
                                                            {gruposAbertos.includes(grupo.idgrupomsgwhats) ? <ExpandLess /> : <ExpandMore />}
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>

                                                {/* Linha de mensagens */}
                                                {gruposAbertos.includes(grupo.idgrupomsgwhats) && grupo.mensagens && (
                                                    <TableRow>
                                                        <TableCell colSpan={4} style={{ paddingLeft: '50px', backgroundColor: '#f9f9f9' }}>
                                                            <Table size="small">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell style={{ width: '10%' }}>Código</TableCell>
                                                                        <TableCell style={{ width: '70%', maxWidth: '70%' }}>Mensagem</TableCell>
                                                                        <TableCell>Ações</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {grupo.mensagens.map(msg => (
                                                                        <TableRow key={msg.idmsgwhats}>
                                                                            <TableCell style={{ width: '10%' }}>{msg.idmsgwhats}</TableCell>
                                                                            <TableCell style={{ width: '70%', maxWidth: '70%' }}>{msg.descricao}</TableCell>
                                                                            <TableCell>
                                                                                <DeleteForeverOutlinedIcon
                                                                                    onClick={() => this.handleDeleteMensagemGrupo(grupo.idgrupomsgwhats, msg.idmsgwhats)}
                                                                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                                    {(groupSelectedAddMessage === grupo.idgrupomsgwhats) && (
                                                                        <TableRow>
                                                                            <TableCell style={{ width: '10%' }} />
                                                                            <TableCell style={{ width: '70%', maxWidth: '70%' }}>
                                                                                <div style={{ width: '100%', maxWidth: '300px' }}>
                                                                                    <FormControl fullWidth>
                                                                                        <Autocomplete
                                                                                            options={listaMensagens}
                                                                                            getOptionLabel={(option) => option.descricao || ''}
                                                                                            value={selectedValue}
                                                                                            inputValue={inputValue}
                                                                                            onInputChange={(event, newInputValue) => {
                                                                                                this.setState({ inputValue: newInputValue });
                                                                                            }}
                                                                                            onChange={(event, newValue) => {
                                                                                                if (newValue) {
                                                                                                    this.handleAdicionarMensagemAoGrupo(grupo.idgrupomsgwhats, newValue);
                                                                                                    this.setState({ selectedValue: null, inputValue: '' }, () => {
                                                                                                        if (this.inputRef.current) {
                                                                                                            this.inputRef.current.blur();
                                                                                                        }
                                                                                                    });
                                                                                                }
                                                                                            }}
                                                                                            renderInput={(params) => (
                                                                                                <TextField
                                                                                                    {...params}
                                                                                                    inputRef={this.inputRef}
                                                                                                    label="Inserir mensagem"
                                                                                                    variant="standard"
                                                                                                    size="small"
                                                                                                    fullWidth
                                                                                                />
                                                                                            )}
                                                                                            disableClearable={false}
                                                                                        />
                                                                                    </FormControl>
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell />
                                                                        </TableRow>
                                                                    )}

                                                                    <TableRow>
                                                                        <TableCell
                                                                            colSpan={3}
                                                                            style={{
                                                                                padding: '0',
                                                                                width: '100%',
                                                                                backgroundColor: '#ffffff',
                                                                            }}
                                                                        >
                                                                            <ButtonBase
                                                                                onClick={() => this.handleAddMensagem(grupo.idgrupomsgwhats)}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '100%',
                                                                                    padding: '0',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    alignItems: 'center',
                                                                                }}
                                                                            >
                                                                                <AddIcon fontSize="small" color="primary" />
                                                                            </ButtonBase>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </TableBody>
                                </Table>
                            </PerfectScrollbar>
                        </CardContent>
                    </Card>
                </div>

                <div>
                    {/* Alerta de Informação */}
                    <AlertInformation
                        open={this.state.openAlert}
                        handleClose={this.handleCloseAlert}
                        message={this.state.messageAlert}
                    />

                    {/* Modal de Confirmação de Exclusão */}
                    <DeleteConfirmationModal
                        open={this.state.openDeleteGrupoConfirmation}
                        handleClose={this.handleCloseDeleteGrupoConfirmation}
                        itemId={this.state.selectedGrupo}
                        message={"Confirma exclusão do grupo " + this.state.selectedGrupo + '?'}
                        handleDelete={() => this.handleDeleteGrupo(this.state.selectedGrupo)}
                    />
                </div>
            </div>
        );
    }
}

export default GrupoMsgWhatsAppFornecedor;